var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdnroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    fill: "none",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a4c639",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5 53.236c2.082 0 3.77 1.685 3.77 3.764v16.147c0 2.08-1.688 3.764-3.77 3.764s-3.77-1.685-3.77-3.764V57c0-2.08 1.688-3.764 3.77-3.764z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.893 33.822l-.023.433V58.72c0 2.63 2.086 4.75 4.675 4.75H95.46c2.59 0 4.675-2.12 4.675-4.75l-.017-24.897H65.893z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.506 53.236c2.082 0 3.77 1.685 3.77 3.764v16.147c0 2.08-1.688 3.764-3.77 3.764s-3.77-1.685-3.77-3.764V57c0-2.08 1.688-3.764 3.77-3.764zM59.813 36c2.082 0 3.77 1.685 3.77 3.764V55.91c0 2.08-1.688 3.764-3.77 3.764s-3.77-1.685-3.77-3.764V39.764c0-2.08 1.687-3.764 3.77-3.764zm46.38 0c2.082 0 3.77 1.685 3.77 3.764V55.91c0 2.08-1.688 3.764-3.77 3.764s-3.77-1.685-3.77-3.764V39.764a3.77 3.77 0 0 1 3.77-3.764zm-40.19-3.784c.105-7.515 6.673-13.676 15.105-14.488h3.788c8.432.812 15 6.974 15.105 14.488H66.003z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.314 17.002l3.976 6.878m27.4-6.878l-3.977 6.878",
    stroke: "#a4c639",
    strokeWidth: 0.793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.938 25.48c.003 1.05-.867 1.904-1.945 1.907s-1.952-.846-1.956-1.897v-.01c-.003-1.05.868-1.904 1.945-1.907s1.952.846 1.956 1.897v.01zm14.558 0c.003 1.05-.867 1.904-1.945 1.907s-1.952-.846-1.956-1.897v-.01c-.003-1.05.868-1.904 1.945-1.907s1.952.846 1.956 1.897v.01z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdnroid);
export default __webpack_public_path__ + "static/media/Adnroid.d2daa5de976397198e853fa80d3f266d.svg";
export { ForwardRef as ReactComponent };